import { useRef } from 'react';
import { useSelector } from 'react-redux';

import LordIcon from 'components/global/LordIcon';
import LottiePlayer from 'components/global/LottiePlayer';
import Typography from 'components/global/Typography';

import { THEME } from 'utils/Theme';

import * as S from './ModuleToolTipContainer.styled';

// Mapping of lottie file keys to actual files
const lottieFiles = {
	/* eslint-disable camelcase */
	lottie_multiBrand: 'module-multiBrand',
	lottie_warehouseLottie: 'module-warehouseLottie',
	lottie_aggregatorImage: 'module-aggregatorImage',
	lottie_returnLottie: 'module-returnLottie',
	lottie_branchLottie: 'module-branchLottie',
	lottie_smsLottie: 'module-smsModule',
	lottie_shippingAutomation: 'module-shippingAutomation',
	lottie_customerServiceLottie: 'module-customerServiceLottie',
	lottie_wmsLottie: 'module-wmsLottie',
	lottie_apiLottie: 'module-apiLottie',
	lottie_emailWhatsappLottie: 'module-emailWhatsappLottie',
	lottie_otoFlexLottie: 'module-otoFlexLottie',
	lottie_omsModuleLottie: 'module_oms_module',
	lottie_clickAndCollect: 'module_ClickAndCollect',
	lottie_advancedShippingAutomation: 'advanced-shipping-automation',
	lottie_shippingAccounting: 'shipping-accounting',
	lottie_wmsAdvanceModule: 'wms-advance-module',
	lottie_customizableRoleSystem: 'customizableRoleSystem',
	lottie_pimModule: 'pimModule',
	lottie_workflowAutomationModule: 'module-workflowAutomationModule',
	lottie_otolink: 'module-otoLinkModule'
	/* eslint-enable camelcase */
};

/**
 * ModuleToolTipContainer component for displaying module information in tooltips
 * @param {Object} props - Component props
 * @param {string} props.infoImage - Image path or lottie key for the information image
 * @param {string} props.title - Title of the module
 * @param {string} props.description - Description of the module
 * @param {string} props.id - Optional ID for the container
 * @param {string} props.lordIcon - Optional lordIcon path
 * @returns {JSX.Element} Tooltip container component
 */
const ModuleToolTipContainer = ({ infoImage, title, description, id, lordIcon }) => {
	const darkMode = useSelector((state) => state.layout.darkMode);
	const isLottie = infoImage && infoImage.slice(0, 7) === 'lottie_';
	const targetRef = useRef(null);

	return (
		<S.ToolTipContainer id={id} ref={targetRef}>
			{isLottie ? (
				<LottiePlayer
					name={lottieFiles[infoImage]}
					width="100px"
					height="100px"
					style={{ marginTop: '1rem' }}
				/>
			) : lordIcon ? (
				<LordIcon
					primaryColor={darkMode ? THEME.WHITE : THEME.BLACK}
					secondaryColor={darkMode ? THEME.DARK.PRIMARY_COLOR : THEME.LIGHT.PRIMARY_COLOR}
					src={lordIcon}
					target={targetRef}
					width={72}
					height={72}
				/>
			) : (
				<img src={infoImage ?? ''} width="100" alt={title} />
			)}
			<Typography noWrap variant="p1" align="center">
				{title}
			</Typography>
			<Typography noWrap align="center" style={{ padding: '0rem 1.5rem 1.5rem 1.5rem ' }}>
				{description}
			</Typography>
		</S.ToolTipContainer>
	);
};

export default ModuleToolTipContainer;
